import React from 'react';
import LazyPageLoader from '../../cmp/LazyPageLoader';

const Page = React.lazy(()=>import('./PagesIndex'))

export default function LazyPagesBuilder(props){
    return <React.Suspense fallback={<LazyPageLoader />}>
        <Page  />
    </React.Suspense>
}
